import '../../Styles/CommunityStyles/header.css'
import header from '../../Assets/header.jpg'

export default function CommunityHeader() {
  return (
    <div className='Cheader'>
        <div className="headerContainer">
            <div className="leftSide">
                <div className="HeaderLogo">
                    <img src={header} alt="" />
                </div>
                <div className="supix">Supix</div>
            </div>
            <div className="rightSide">
              <div className="pixnft">pixnft</div>
              <div className="nftoken">nftoken</div>
            </div>
        </div>
    </div>
  )
}
